export default __webpack_public_path__ + "523427ba46abaaceff8dc833653be590.png";